import React, { createContext, useContext } from "react";
import { useUserData } from "../hooks/useUserData";

const UserDataContext = createContext(null);

// Provides ONE polling source of on-chain user data to every tab,
// so we don't run multiple intervals.
export function UserDataProvider({ children }) {
  const value = useUserData();
  return <UserDataContext.Provider value={value}>{children}</UserDataContext.Provider>;
}

export function useUserDataCtx() {
  const ctx = useContext(UserDataContext);
  if (!ctx) throw new Error("useUserDataCtx must be used within UserDataProvider");
  return ctx;
}
